import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  data: {} | null;
  token: string | null;
  userType: string | null;
}

const initialState: AuthState = {
  data: null,
  token: null,
  userType: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload.data;
      state.token = action.payload.token;
      state.userType = action.payload.userType;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, reset } = authSlice.actions;
export const getAuthDetails = (state: any) => state.auth.data;
export const getUserType = (state: any) => state.auth.userType;
export const getUserId = (state: any) => state.auth.data?.id;

export default authSlice.reducer;
